module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Bold_33343488.1fc52274.ttf";